import PropTypes from 'prop-types';
import classNames from 'classnames';

const VenueContentBlockItem = ({
  count,
  title,
  icon,
  iconAltText,
  displayCount,
}) => {
  const classes = classNames('venue-content-block__text', {
    'venue-content-block__text-no-icon': icon === null,
  });

  return (
    <>
      <li>
        {displayCount && (
          <span className="venue-content-block__quantity">{count || '0'}</span>
        )}
        {icon && (
          <img
            className="venue-content-block__icon"
            src={icon}
            alt={iconAltText}
          />
        )}
        <h4 className={classes}>{title}</h4>
      </li>
    </>
  );
};

VenueContentBlockItem.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconAltText: PropTypes.string,
  displayCount: PropTypes.bool,
};

VenueContentBlockItem.defaultProps = {
  displayCount: true,
};

export default VenueContentBlockItem;
